export default {
  gewerbe: {
    hero: {
      eyebrow: 'Clienti aziendali',
      title: 'Videosorveglianza professionale per esigenze aziendali',
      lead: 'Dalla filiale al dettaglio al capannone di produzione: pianifichiamo, installiamo e gestiamo sistemi di telecamere al servizio della tua azienda. Rispettosi della privacy, scalabili e affidabili.',
    },
    types: {
      title: 'Soluzioni per la tua azienda',
      lead: 'Ogni settore ha esigenze proprie. Conosciamo le sfide tipiche e pianifichiamo di conseguenza.',
      items: {
        '0': { title: 'Commercio e negozi', desc: 'Ingresso, area vendita, cassa e magazzino: sorvegliati in modo discreto ed efficace. Protezione da furti e vandalismo.', tags: { '0': 'Interno', '1': 'Antifurto', '2': 'Cassa' } },
        '1': { title: 'Uffici e studi', desc: 'Reception, corridoi, aree sensibili e parcheggi, con diritti di accesso e zone private.', tags: { '0': 'Interno', '1': 'Reception', '2': 'Privacy' } },
        '2': { title: 'Magazzino e logistica', desc: 'Sorveglianza di grandi superfici con grandangolo e PTZ. Visione di zone di consegna, scaffali ed esterni giorno e notte.', tags: { '0': 'Interno', '1': 'Esterno', '2': 'Visione notturna' } },
        '3': { title: 'Ristorazione', desc: 'Ingresso, bancone, accesso cucina ed esterno: telecamere robuste per ambienti umidi e caldi.', tags: { '0': 'Interno', '1': 'Esterno', '2': 'Robusto' } },
        '4': { title: 'Officine e industria', desc: 'Ambienti più difficili richiedono telecamere particolarmente robuste. Officine, esterni e zone di carico protette.', tags: { '0': 'Interno', '1': 'Robusto', '2': 'Visione notturna' } },
        '5': { title: 'Più sedi', desc: 'Accesso centrale a tutte le telecamere da un’unica app. Gestione utenti con diritti differenziati.', tags: { '0': 'Multi-sede', '1': 'Centrale', '2': 'App' } },
      },
    },
    features: {
      title: 'Funzioni per uso aziendale',
      lead: 'Le installazioni commerciali richiedono più delle sole telecamere. Configuriamo diritti, piani di registrazione e notifiche in modo professionale.',
      items: {
        '0': { title: 'Gestione utenti', desc: 'Diritti di accesso diversi per dipendenti, responsabili di filiale e direzione. Chi può vedere quale telecamera?' },
        '1': { title: 'Registrazione e archiviazione', desc: 'Registratore locale con archiviazione ridondante. Durata secondo requisiti operativi ed eventualmente legali.' },
        '2': { title: 'Notifiche eventi', desc: 'Messaggi push su movimento, attraversamento di linea o eventi definiti, a seconda del sistema.' },
        '3': { title: 'Espandibilità', desc: 'La tua azienda cresce? I sistemi esistenti possono di solito essere ampliati con altre telecamere e sedi.' },
      },
    },
    legal: {
      eyebrow: 'Privacy e diritto',
      title: 'Videosorveglianza aziendale conforme',
      lead: 'Per la videosorveglianza commerciale valgono norme aggiuntive, specie per dipendenti, clienti e aree pubbliche. Ti supportiamo nell’implementazione tecnica di:',
      list: {
        '0': 'Trasparenza e segnaletica agli ingressi',
        '1': 'Mascheramento di spogliatoi e sale pausa',
        '2': 'Implementazione tecnica di diritti di accesso e utenti',
        '3': 'Archiviazione locale con periodo di conservazione definito',
        '4': 'Documentazione della necessità operativa',
      },
      note: 'Nota: la liceità della videosorveglianza aziendale dipende dal caso. Ti consigliamo tecnicamente, senza sostituire la consulenza legale.',
    },
    cta: {
      title: 'La tua azienda merita sicurezza professionale',
      lead: 'Analizziamo i tuoi processi e pianifichiamo un sistema che protegge senza disturbare. Senza impegno e con trasparenza.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Scopri SSG Care',
    },
  },
};